import React from "react";
import { StaticImage } from "gatsby-plugin-image";

const HomeHeaderImage = ({ className = "" }) => (
  <StaticImage
    className={className}
    //src="https://res.cloudinary.com/dbsf5zd0e/image/upload/v1738877826/cerramientos-madrid_i0fojm.jpg"
    src="../images/cerramientos-madrid.jpg"
    alt="Cerramientos en Madrid"
    placeholder="blurred"
    quality={75}
    width={1536}
    height={1024}
    //width={1920}
    //height={998}
    priority
    formats={["auto", "webp", "avif"]}
  />
);

export default HomeHeaderImage;
